import styled from "styled-components"
import menuHover from "../assets/menuHover.png"

const LinkAnimated = styled.span`
  > a {
    text-decoration: none;
    position: relative;
    color: #000000;
    text-transform: uppercase;
    cursor: ${props => (props.onClick ? "pointer" : "default")};

    &:hover {
      cursor: pointer;
    }

    &:before {
      content: "";
      background-image: url('${menuHover}');
      background-size: cover;
      position: absolute;
      top: 0;
      width: 15px;
      height: 0;
      left: 50%;
      margin-left: 10px;
      transform: translateX(-50%);
      transition-property: all;
      transition-duration: 0.3s;
      transition-timing-function: ease-out;
    }

    &.active:before,
    &:hover:before {
      top: -30px;
      height: 15px;
    }

    @media screen and (max-width: 639px) {
      &.active, &:hover {
        text-decoration: underline;
        &:before {
          top: 0;
          height: 0;
        }
      }
    }
  }
`

export default LinkAnimated
